import { RouteInfo } from '../vertical-menu/vertical-menu.metadata';

export const HROUTES: RouteInfo[] = [

  {
    path: '', title: 'Quản lý giá đất', icon: 'ft-grid', class: 'dropdown nav-item has-sub', isExternalLink: false, code: 'parent/qlgd', alwaysShow: false,
    submenu: [
      { path: '/danhmuc/bang-gia', title: 'Bảng giá đất cụ thể', icon: 'ft-arrow-right submenu-icon', class: 'dropdown-item',
        isExternalLink: false, submenu: [], code: '/danhmuc/bang-gia', alwaysShow: false },
      // { path: '/ql-gia-dat/thuoc-tinh', title: 'Giá đất theo thuộc tính', icon: 'ft-arrow-right submenu-icon', class: 'dropdown-item',
      //   isExternalLink: false, submenu: [], code: '/ql-gia-dat/thuoc-tinh', alwaysShow: false },
      // { path: '/ql-gia-dat/ban-do', title: 'Giá đất theo bản đồ', icon: 'ft-arrow-right submenu-icon', class: 'dropdown-item',
      //   isExternalLink: false, submenu: [], code: '/ql-gia-dat/ban-do', alwaysShow: false },
      // { path: '/ql-gia-dat/cau-hinh-mau-sac', title: 'Cấu hình màu sắc', icon: 'ft-arrow-right submenu-icon', class: 'dropdown-item',
      //   isExternalLink: false, submenu: [], code: '/ql-gia-dat/cau-hinh-mau-sac', alwaysShow: false },
      //   { path: '/ql-gia-dat/phieu-dieu-tra', title: 'Phiếu điều tra', icon: 'ft-arrow-right submenu-icon', class: 'dropdown-item',
      //   isExternalLink: false, submenu: [], code: '/ql-gia-dat/phieu-dieu-tra', alwaysShow: false }

    ]
  },
  {
    path: '', title: 'Danh mục', icon: 'ft-folder', class: 'dropdown nav-item has-sub', isExternalLink: false, code: 'parent/danh-muc', alwaysShow: false,
    submenu: [
      // { path: '/danhmuc/loaidanhmuc', title: 'Loại danh mục', icon: 'ft-arrow-right submenu-icon', class: 'dropdown-item', isExternalLink: false, submenu: [] },
      { path: '/danhmuc/bang-gia-dat', title: 'Bảng giá đất', icon: 'ft-arrow-right submenu-icon', class: 'dropdown-item',
        isExternalLink: false, submenu: [], code: '/danhmuc/bang-gia-dat', alwaysShow: false },
      { path: '/danhmuc/duong', title: 'Đường', icon: 'ft-arrow-right submenu-icon', class: 'dropdown-item',
        isExternalLink: false, submenu: [], code: '/danhmuc/duong', alwaysShow: false },
      { path: '/danhmuc/doan-duong', title: 'Đoạn đường', icon: 'ft-arrow-right submenu-icon', class: 'dropdown-item',
        isExternalLink: false, submenu: [], code: '/danhmuc/doan-duong', alwaysShow: false },
      { path: '/danhmuc/khu-vuc', title: 'Khu vực', icon: 'ft-arrow-right submenu-icon', class: 'dropdown-item',
        isExternalLink: false, submenu: [], code: '/danhmuc/khu-vuc', alwaysShow: false },
      { path: '/danhmuc/vi-tri', title: 'Vị trí', icon: 'ft-arrow-right submenu-icon', class: 'dropdown-item',
        isExternalLink: false, submenu: [], code: '/danhmuc/vi-tri', alwaysShow: false },
      { path: '/danhmuc/gia-nha', title: 'Giá nhà', icon: 'ft-arrow-right submenu-icon', class: 'dropdown-item',
        isExternalLink: false, submenu: [], code: '/danhmuc/gia-nha', alwaysShow: false },
      { path: '/danhmuc/loai-nha', title: 'Loại nhà', icon: 'ft-arrow-right submenu-icon', class: 'dropdown-item',
        isExternalLink: false, submenu: [], code: '/danhmuc/loai-nha', alwaysShow: false },
      { path: '/danhmuc/cap-nha', title: 'Cấp nhà', icon: 'ft-arrow-right submenu-icon', class: 'dropdown-item',
        isExternalLink: false, submenu: [], code: '/danhmuc/cap-nha', alwaysShow: false },
      { path: '/danhmuc/chat-luong-nha', title: 'Chất lượng nhà', icon: 'ft-arrow-right submenu-icon', class: 'dropdown-item',
        isExternalLink: false, submenu: [], code: '/danhmuc/chat-luong-nha', alwaysShow: false },
      { path: '/danhmuc/he-so-dat', title: 'Hệ số đất', icon: 'ft-arrow-right submenu-icon', class: 'dropdown-item',
        isExternalLink: false, submenu: [], code: '/danhmuc/he-so-dat', alwaysShow: false },
      { path: '/danhmuc/loai-he-so-dat', title: 'Loại hệ số đất', icon: 'ft-arrow-right submenu-icon', class: 'dropdown-item',
        isExternalLink: false, submenu: [], code: '/danhmuc/loai-he-so-dat', alwaysShow: false },
    ]
  },
  {
    path: '', title: 'Cấu hình', icon: 'ft-settings', class: 'dropdown nav-item has-sub', code: 'parent/settings', alwaysShow: true,
    isExternalLink: false,
    submenu: [
      { path: '/cau-hinh/menu', title: 'Cấu hình menu', icon: 'ft-arrow-right submenu-icon', class: 'dropdown-item',
        isExternalLink: false, submenu: [], code: '/settings/menu', alwaysShow: true },
      
    ]
  },

];
